import { apiClient, type PartnerExEntity } from '@/libs/api'

export type FetchPartnerDetailQuery = {
  tenantKey: string
  partnerId: number
}

export type FetchPartnerDetailResponse = PartnerExEntity

export const fetchPartnerDetail = async (
  { tenantKey, partnerId }: FetchPartnerDetailQuery,
  signal?: AbortSignal
): Promise<FetchPartnerDetailResponse> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .partners._id(partnerId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
